import {
  GET_CER,
  ADD_CER,
  UPDATE_CER,
  DELETE_CER,
  REQUEST_CER,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: []
}

const mutations = {
  [GET_CER] (state, cers) {
    state.all = cers
  },
  [ADD_CER] (state, contact) {
    state.all.push(contact)
    toastr.success('Le CER a été créé')
  },
  [UPDATE_CER] (state, oldContact, updatedContact) {
    state.all.$remove(oldContact)
    state.all.push(updatedContact)
    toastr.success('Le CER a été modifié')
  },
  [DELETE_CER] (state, contact) {
    state.all.$remove(contact)
    toastr.success('Le CER a été supprimé')
  },
  [REQUEST_CER] (state) {
    state.error = false
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cers.js